import React, { useRef, useState } from 'react';
import useAzertyConverter from '../../../../../hooks/useAzertyConverter';
import PropTypes from 'prop-types';

const SearchInput = ({ onChange, placeholder, useAzerty = false }) => {
  const inputRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const { handleInputChange, handleKeyDown } = useAzertyConverter();

  const handleChange = (e) => {
    const value = useAzerty ? handleInputChange(e) : e.target.value;
    setIsEmpty(value === '');
    onChange(value);
  };

  const handleKeyDownEvent = (e) => {
    if (useAzerty) {
      handleKeyDown(e);
    }
  };

  return (
    <div className="relative w-full">
      <div className="relative">
        <input
          ref={inputRef}
          type="text"
          className="w-full pl-10 pr-4 py-2 bg-white border-2 border-gray-300 rounded-lg 
                   text-gray-900 placeholder-gray-500
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   hover:border-blue-400 transition-colors duration-200"
          onChange={handleChange}
          onKeyDown={handleKeyDownEvent}
          placeholder={placeholder}
        />
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg 
            className="h-5 w-5 text-blue-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            strokeWidth="2.5"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
            />
          </svg>
        </div>
        {!isEmpty && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            <button
              onClick={() => {
                if (inputRef.current) {
                  inputRef.current.value = '';
                  setIsEmpty(true);
                  onChange('');
                }
              }}
              className="text-gray-500 hover:text-gray-700 focus:outline-none transition-colors duration-200"
            >
              <svg 
                className="h-5 w-5" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                strokeWidth="2.5"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  useAzerty: PropTypes.bool
};

export default SearchInput; 